module.exports = __webpack_public_path__ + "static/media/TM.33f1c1cd.svg";